export default __webpack_public_path__ + "static/media/nestlypay2.e0bc2214.png";